import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./Sidebar.module.scss";
import clsx from "clsx";
import { RefObject } from "react";
import { ESectionOptions, sidebarOptions, sidebarRestrictedOptions } from "../const/const";

type TSidebarProps = {
  selectedSection: ESectionOptions;
  sectionRefs: Record<ESectionOptions, RefObject<HTMLDivElement>>;
  top: number;
  sidebarRef: RefObject<HTMLDivElement>;
};

export function Sidebar({ selectedSection, sectionRefs, top, sidebarRef }: TSidebarProps) {
  function scrollToSection(section: ESectionOptions) {
    const ref = sectionRefs[section];
    if (ref && ref.current) {
      const topPosition = ref.current.getBoundingClientRect().top + window.scrollY - top;
      window.scrollTo({
        top: topPosition,
        behavior: "smooth"
      });
    }
  }

  function onClickSection(section: ESectionOptions) {
    scrollToSection(section);
  }

  return (
    <div className={styles.container} ref={sidebarRef}>
      <div className={styles.subContainer}>
        {sidebarOptions.map((option) => {
          const optionColor = selectedSection === option ? "greyscale700" : "greyscale400";
          return (
            <Typography
              color={optionColor}
              variant="label-4"
              onClick={() => onClickSection(option as ESectionOptions)}
              key={option}
              className={clsx(styles.option, selectedSection === option && styles.selected)}
            >
              {option}
            </Typography>
          );
        })}
        <div className={styles.divider} />
      </div>
    </div>
  );
}
